import swal from 'sweetalert'

class RlinkAppsStatusController {
  constructor ($log, VehicleService, ProductService, IdsService, $state, $translate, I18n, Localization, StoreTypes) {
    'ngInject'
    this.productService = ProductService
    this.vehicleService = VehicleService
    this.idsService = IdsService
    this.type = Localization.getLocalizedAppConfig().type
    this.StoreTypes = StoreTypes
    this.$translate = $translate
    this.I18n = I18n
    this.$state = $state
    this.$log = $log
    this.nbProductToUpdate = 0
    this.loaded = this.init()
  }

  init () {
    this.errorNoMoreConnectedProduct = {
      message: 'message.errorNoMoreConnectedProducts',
      cause: 'No More Connected Products',
      delay: 0
    }
    return this.vehicleService.getCurrentSelectedVehicle()
    .then((v) => {
      this.vehicle = v

      if (this.vehicle.hasDealerSdSub) {
        this.displayDealerSdActivation()
      }

      if (this.vehicle.isGdcActivationPopinNeedToBeDisplay) {
        this.displayGdcActivation(this.vehicle.vin)
      }

      if (this.vehicle.simStatus === 'CANCELLED' || this.vehicle.simStatus === 'CANCELLING' || this.vehicle.simStatus === 'CANCEL_PENDING') {
        this.displaySimCancelled()
      }

      return this.idsService.decode(this.vehicle.vin)
      .then((res) => {
        this.vehicle.registrationNumber = res
        return this.productService.getNumberProductToUpdate(this.vehicle.vin)
        .then((res) => {
          this.nbProductToUpdate = res.nb
          return res.nb
        }, (err) => {
          this.$log.error('getNumberProductToUpdate error', err)
          this.error = {
            message: 'rlinkAppsStatus.productToUpdateError',
            cause: err
          }
          return Promise.reject(err)
        })
      }, (err) => {
        this.$log.error('Error while decoding svin', err)
        return Promise.reject(err)
      })
    })
    .then(() => {
      this.displayMusAlertMessage()
    })
  }

  displayDealerSdActivation () {
    if (this.$state.is('vehicle.catalog.appsAndServices')) {
      this.success = 'message.dealerSdActivation'
      this.vehicle.hasDealerSdSub = false
    } else {
      this.success = null
    }
  }

  displayGdcActivation (vin) {
    if (this.$state.is('vehicle.catalog.appsAndServices')) {
      this.success = 'message.gdcActivationMail'
      this.vehicleService.changeDisplayGdcActivation(vin)
      this.vehicle.isGdcActivationPopinNeedToBeDisplay = false
    } else {
      this.success = null
    }
  }

  displaySimCancelled () {
    this.errorSimCancelled = {
      message: 'message.simCancelled',
      cause: 'Sim card is cancelled',
      delay: 0
    }
  }

  displayMusAlertMessage () {
    console.log('Get Map Alert Message for VIN ' + this.vehicle.vin)
    return this.vehicleService.getMapAlertMessage(this.vehicle.vin)
    .then((data) => {
      let alertMessage = ''
      let pMsgs = []
      let idList = []
      for (var i in data) {
        if (pMsgs.indexOf(data[i].message) === -1) {
          pMsgs.push(data[i].message)
          alertMessage += this.$translate.instant(data[i].message) + '\n'
        }
        idList.push(data[i].id)
      }
      if (alertMessage) {
        swal({
          text: alertMessage,
          icon: 'info',
          closeOnClickOutside: false,
          content: true
        }).then(confirmed => {
          this.vehicleService.markAlertMessageRead(this.vehicle.vin, idList.toString())
          .then(() => {
            this.$log.debug('MUS alert message marked as read')
          })
        })
      }
    })
  }

  goToMyUpdates () {
    this.$state.go('vehicle.manageMyRlink.myUpdates', {vin: this.vehicle.vin, sync: true})
  }

  askForUpdate () {
    this.success = null
    this.isProcessing = true
    return this.productService.updateProducts(this.vehicle.vin)
      .then((res) => {
        this.isProcessing = false
        return this.$state.go('installation', {success: 'my-updates.update_success'})
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-updates.update_error',
          cause: err
        }
        return Promise.reject(err)
      })
  }

  get isIframe () {
    return (this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.ONE ||
      this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.RSITE)
  }

}

export default RlinkAppsStatusController



// WEBPACK FOOTER //
// ./src/app/common/rlink-apps-status/rlink-apps-status.controller.js